export const IMAGE_PRODUCT_PRESCRIPTION_FALLBACK_SRC =
  '/media/content/placeholder-prescription-ad.png'
